module.exports = __webpack_public_path__ + "static/media/horrormax-banner-carnivale-creepshow.8eb7c85e.jpg";